import React, { useRef, useState } from 'react';

import Grid from '@mui/material/Unstable_Grid2';
import { Divider, Typography, Box, AppBar, Link, Toolbar, IconButton, SpeedDial, SpeedDialIcon, SpeedDialAction } from '@mui/material';
import { styled } from '@mui/material/styles';
import ShareIcon from '@mui/icons-material/Share';
import RefreshIcon from '@mui/icons-material/Refresh';
import PrintIcon from '@mui/icons-material/Print';
import LocalSeeIcon from '@mui/icons-material/LocalSee';
import Caculator from './Caculator';
import ImageProcessor from './ImageProcessor';

import Workspace, { jsonTransferHelper } from './Workspace';

import html2canvas from 'html2canvas';

const BillSpliter = (props) => {
    const [imageProcessorOpened, setImageProcessorOpened] = useState(false);

    const table = useRef(null);

    const clearTable = () => {
        table?.current?.refresh();
    }

    const print = () => {
        table?.current?.screenshot();
    }

    const openImageProcessor = () => {
        setImageProcessorOpened(true);
    }

    	// Handler for processing results
	const handleImageProcess = (result) => {
		console.log('Processing result:', result);
	};

    const shareWorkspace = () => {
        table?.current?.shareWorkspace();
    }

    const actions = [
        { icon: <LocalSeeIcon />, name: 'Receipt Reader', operation: openImageProcessor },
        { icon: <ShareIcon />, name: 'Share', operation: shareWorkspace },
        { icon: <PrintIcon />, name: 'Print', operation: print },
        { icon: <RefreshIcon />, name: 'Refresh', operation: clearTable },
    ];



    return (
        <>
            <AppBar>
                <Toolbar>
                    <Box component='img' src='/images/label.svg'></Box>

                    <Typography
                        align="right"
                        sx={{ fontSize: "20px", fontFamily: 'sans-serif', margin: '20px', flexGrow: 1 }}
                    >
                        <Link
                            underline="none"
                            href='http://robinseasky.org'
                            color='primary.contrastText'
                            target="_blank"
                            rel="noopener"

                        >
                            About Author
                        </Link>
                    </Typography>

                </Toolbar>
            </AppBar>
            <Box sx={{ position: 'sticky', top: '10vh', left: 0, flexGrow: 1, zIndex:10 }}>
                <SpeedDial
                    ariaLabel="Caculator Tool"
                    sx={{ position: 'absolute', left: '15px', top: 0 }}
                    icon={<SpeedDialIcon />}
                    direction='down'
                >
                    {actions.map((action) => (
                        <SpeedDialAction
                            key={action.name}
                            icon={action.icon}
                            tooltipTitle={action.name}
                            onClick={action.operation}
                        />
                    ))}
                </SpeedDial>
            </Box>
            <Grid container
                direction="column"
                justifyContent="flex-start"
                alignItems='center'
                spacing={3}
                sx={{
                    marginTop: '80px',
                }}
            >
                <Grid>
                    <Typography
                        align="center"
                        sx={{ fontSize: "40px", fontFamily: 'sans-serif' }}
                        color="primary"
                    >
                       Costco Split <Box component='img' sx={{
                            width: '80px',
                            position: 'relative',
                            top: '20px',
                        }}  src="/images/bill-split.svg" alt="bill split" /> 分 账 助 手
                    </Typography>
                </Grid>
                <Grid>
                    <Typography
                        align="center"
                        sx={{ fontSize: "36px", fontFamily: 'serif' }}
                        color="secondary"
                    >
                        Smart way to split your Costco bills.   自动计算， 轻松拼单。
                    </Typography>
                </Grid>
                <Grid>
                    <Box sx={{
                        width: '95vw',
                        height: '1px',
                        background: 'black',
                    }}></Box>
                </Grid>
                <Grid>
                    <Caculator ref={table} />
                </Grid>
            </Grid>
            <ImageProcessor
                open={imageProcessorOpened}
                onClose={() => setImageProcessorOpened(false)}
                onProcess={handleImageProcess}
                tableRef={table}
            />
        </>
    )

}

export default BillSpliter;